import { useRef } from 'react'
import { BiDotsVerticalRounded } from 'react-icons/bi'
import { useOnClickOutside } from 'usehooks-ts'
import {
  DropDownItem,
  DropDownItemButton,
  MoreOptionsButton,
  OptionsDropDown,
  OptionsDropDownContent
} from './group-booking-options-styles'

type OptionButtonProps = {
  title: string
  onClick: () => void
  disabled?: boolean
}

type GroupBookingOptionsProps = {
  expanded: boolean
  onToggle: (open: boolean) => void
  optionButtons: OptionButtonProps[]
}

const GroupBookingOptions = ({ expanded, onToggle, optionButtons }: GroupBookingOptionsProps) => {
  const ref = useRef<HTMLDivElement>(null)

  const handleClickOutside = () => {
    onToggle(false)
  }

  useOnClickOutside(ref, handleClickOutside)

  return (
    <OptionsDropDown data-testid="More-options-dropdown" ref={ref}>
      <MoreOptionsButton
        data-testid="More-options-button"
        role="button"
        title={'Organiser Options'}
        onClick={() => onToggle(true)}
      >
        <BiDotsVerticalRounded size={30} />
      </MoreOptionsButton>
      {expanded ? (
        <OptionsDropDownContent>
          {optionButtons.map(item => (
            <DropDownItem key={item.title}>
              <DropDownItemButton
                onClick={() => {
                  item.onClick()
                  onToggle(false)
                }}
                disabled={item.disabled}
              >
                {item.title}
              </DropDownItemButton>
            </DropDownItem>
          ))}
        </OptionsDropDownContent>
      ) : null}
    </OptionsDropDown>
  )
}

export default GroupBookingOptions
